import axios from "axios";

export default {
  name: "account-receive",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAccountReceive(store, { id,tab,jenis }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "account_receivable",
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          params: { id: id, tab:tab, 
            jenis: jenis, tlc:store.getters.getAuth.username },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    
    releaseAR(store, { auth, id, jenis_transaksi }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "account_receivable/cancel_ar",
          data: {
            id: id,
            jenis_transaksi: jenis_transaksi
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getManifestAR(store, { id,tab,jenis }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "account_receivable",
          params: { id: id, tab:tab, 
            jenis_transaksi: jenis, tlc:store.getters.getAuth.username },
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
};
